var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48974 6.45413C1.59548 6.72505 1.7609 6.96786 1.97336 7.16397C2.18582 7.36009 2.43969 7.50432 2.71554 7.58563L8.78245 9L2.77259 10.3359C2.49037 10.4143 2.22998 10.5581 2.01196 10.756C1.79394 10.9539 1.62428 11.2006 1.51636 11.4764L0.0737877 16.5862C-0.00514101 16.7844 -0.0212122 17.0027 0.0278088 17.2106C0.0768297 17.4185 0.188507 17.6058 0.347312 17.7464C0.506118 17.8869 0.70416 17.9738 0.913903 17.995C1.12365 18.0161 1.33467 17.9704 1.51763 17.8643L15.4768 9.90005C15.6354 9.8111 15.7675 9.6807 15.8595 9.52242C15.9515 9.36413 16 9.18374 16 9C16 8.81625 15.9515 8.63586 15.8595 8.47758C15.7675 8.3193 15.6354 8.1889 15.4768 8.09995L1.51763 0.135749C1.33467 0.0295983 1.12365 -0.0160905 0.913903 0.00503504C0.70416 0.0261606 0.506118 0.113051 0.347312 0.253624C0.188507 0.394198 0.0768297 0.581469 0.0278088 0.7894C-0.0212122 0.997331 -0.00514101 1.21559 0.0737877 1.41383L1.48974 6.45413Z",
    fill: "#AAB0B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.07da6f9aa375c33f6ef82f3c359fdd93.svg";
export { ForwardRef as ReactComponent };